// "Crewbench" is a placeholder name: rename the product here only.
export const APP_NAME = "Crewbench";

// How the roles read on screen ("owner" reads as "Founder" and "coder" as "Independent professional", for a more
// premium tone). The role ids (owner, coder, platform_admin) stay as they are in the API and the database; the
// addresses read like the screen: the founder's pages are under /founder and the team's under /team.
// the AI wallet's refunds (backend/wallet.py; the terms, section 11): what isn't paid back
export const NOT_REFUNDABLE = "Some fees aren't refundable: the part of an extra seat's price beyond its credit bonus, the server's 3 grace days after a plan ends, server time already used, and the payment provider's fee on a refunded amount.";
export const ROLE_LABELS = { owner: "Founder", coder: "Independent professional", viewer: "Investor", platform_admin: "Platform admin" };
// where each role lands after signing in (investors: their read-only view, backend/investor_routes.py)
export const homeFor = (role) => ({ owner: "/founder", coder: "/team", viewer: "/investor" }[role] || "/admin/companies");
export const roleLabel = (role) => ROLE_LABELS[role] || role || "";
// A coder is a team member (the company's own staff, engagement "employee") or an independent professional (hired for a
// task; also when the field is missing). backend/engagement.py; TEAM_ROLES_PLAN.md section 5.
export const ENGAGEMENT_LABELS = { independent: "Independent professional", employee: "Team member" };
export const engagementOf = (person) => (person?.engagement === "employee" ? "employee" : "independent");
// how one person reads on screen: Founder, Team member or Independent professional
export const titleOf = (person) => (person?.role === "coder" ? ENGAGEMENT_LABELS[engagementOf(person)] : roleLabel(person?.role));

// Our own labels for the engines; never present the product as "Claude Code" or "Codex".
export const ENGINE_LABELS = {
  mock: "MockEngine (demo)",
  claude: "Claude Agent (Anthropic)",
  codex: "Codex (OpenAI)",
  muse: "Muse Spark (Meta)",
};
